import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class Dialog extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    onOpen: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    onBack: PropTypes.func,
    showBackButton: PropTypes.bool,
    footer: PropTypes.node,
  };

  static defaultProps = {
    onOpen: () => {},
    onConfirm: () => {},
    onCancel: () => {},
    onBack: null,
    showBackButton: false,
    footer: null,
  };

  state = {
    transitioning: false,
    shouldHide: false,
  };

  componentDidMount() {
    const { id, onCancel } = this.props;

    /* eslint-disable no-undef */
    $(`#${id}`).on('show.bs.modal', () => {
      this.props.onOpen();
      this.setState({ transitioning: true });
    });

    $(`#${id}`).on('shown.bs.modal', () => {
      if (this.state.shouldHide) {
        $(`#${id}`).modal('hide');
      }

      this.setState({ transitioning: false, shouldHide: false });
    });

    $(`#${id}`).on('hide.bs.modal', () => {
      onCancel();
    });
    /* eslint-enable no-undef */
  }

  componentWillUnmount() {
    const { id } = this.props;

    // eslint-disable-next-line no-undef
    $(`#${id}`).modal('hide');
  }

  dismiss = () => {
    const { id } = this.props;
    const { transitioning } = this.state;

    if (transitioning) {
      this.setState({ shouldHide: true });
      return;
    }

    // eslint-disable-next-line no-undef
    $(`#${id}`).modal('hide');
  };

  render() {
    const {
      id,
      title,
      children,
      onConfirm,
      onBack,
      showBackButton,
      footer,
    } = this.props;

    return (
      <div
        id={id}
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`${id}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header pt-0">
              <div
                className="col-2 pl-0"
                style={{ paddingTop: 'calc(1.5rem - 2px)' }}
              >
                {showBackButton && (
                  <button
                    type="button"
                    className="btn btn-sm btn-round btn-icon btn-transparent d-flex align-items-center justify-content-center my-0"
                    onClick={onBack}
                  >
                    <i
                      className="fas fa-chevron-left"
                      style={{ marginRight: '2px' }}
                    />
                  </button>
                )}
              </div>

              <div className="col pt-4 text-center">
                <h5>{title}</h5>
              </div>

              <div className="col-2" />

              <button
                type="button"
                className="close pt-1"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body pb-0">{children}</div>

            {footer}

            {footer === null && (
              <div className="modal-footer pt-0">
                <div className="d-flex flex-column w-100">
                  <div className="w-100">
                    <hr />
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-neutral"
                      data-dismiss="modal"
                    >
                      <FormattedMessage
                        id="generic-dialog-cancel"
                        defaultMessage="Peruuta"
                      />
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={onConfirm}
                      data-dismiss="modal"
                    >
                      <FormattedMessage
                        id="generic-dialog-confirm"
                        defaultMessage="Vahvista"
                      />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Dialog;
